// src/padplanner/PadPlannerErrorBoundary.jsx
//
// A render error on a PadPlanner page stays inside the page: the shell keeps
// its bars, and the page says what happened and how to get back. Without it,
// selecting a plan in the list (whose card read the wrong shape of the plan
// answer) blanked the whole app.
//
// PadPlannerGate renders it around every page. The error itself goes to the
// console, not the page: a message can carry a dataset key or an id.
//
// The way back is a link, not a router navigation: a full load starts the
// app from a clean state, whatever state broke the render.
import { Component } from "react";
import { PADPLANNER_DISPLAY_NAME } from "../constants/analyticsProducts";

export const PAGE_ERROR_TEXT = "Something went wrong on this page.";

export default class PadPlannerErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("[padplanner] page render failed", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="flex h-full min-h-0 flex-col items-start gap-3 overflow-auto p-6" data-testid="pp-page-error">
        <p className="text-sm text-fg-primary">{PAGE_ERROR_TEXT}</p>
        <p className="text-sm text-fg-secondary">Your saved plans aren't affected.</p>
        <a href="/padplanner" className="op-btn op-btn--sm">Back to the {PADPLANNER_DISPLAY_NAME} dashboard</a>
      </div>
    );
  }
}
